import { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import API from '../api/axios';

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    API.get('/announcements').then(r => { if (r.data.length > 0) setAnnouncement(r.data[0]); }).catch(() => {});
  }, []);

  if (!announcement || closed) return null;

  return (
    <div className="announcement-banner" style={{ background: announcement.bgColor || '#6c63ff', color: announcement.textColor || '#fff' }}>
      <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', padding: '10px 20px' }}>
        <span style={{ fontSize: '0.9rem', textAlign: 'center' }}>
          {announcement.message}
          {announcement.link && <a href={announcement.link} style={{ color: 'inherit', marginLeft: '8px', fontWeight: '700', textDecoration: 'underline' }}>{announcement.linkText || 'Learn More'}</a>}
        </span>
        {announcement.closable && (
          <button onClick={() => setClosed(true)} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontSize: '1rem', padding: '4px' }}><FaTimes /></button>
        )}
      </div>
    </div>
  );
};

export default AnnouncementBanner;
